import { alpha, Theme } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

const useStyles = {
  devicesHeaderRow: () => ({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 2,
    paddingBottom: 1,
  }),
  devicesHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontWeight: 500,
  },
  emptyStateContainer: {
    rowGap: 3,
    mx: 'auto',
    mt: 22,
    mb: 2,
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '234px',
  },
  emptyStateImageContainer: {
    textAlign: 'center',
  },
  emptyStateDescription: {
    textAlign: 'center',
  },
  buttonGroup: {
    paddingTop: 0,
    paddingBottom: 1.5,
    gap: '2px',
  },
  accordion: () => ({
    boxShadow: 'none',
    ...useSharedStyles.fullWidthContainer,
    '&.MuiAccordion-root.Mui-expanded': {
      margin: '0 -16px ',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: 'transparent',
    },
  }),
  accordionDetails: {
    paddingY: 0,
  },
  accordionSummaryGrid: {
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 1,
    paddingLeft: 2,
  },
  accordionSummaryContent: {
    gap: 1,
    alignItems: 'center',
  },
  accordionDeviceContainer: {
    paddingY: 1,
  },
  firstLevelAccordion: () => ({
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#E0EEFC',
    },
  }),
  secondLevelAccordion: (theme: Theme) => ({
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#EAF3FC',
    },
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.ui.inversePrimary}`,
    },
  }),
  placeIcon: (theme: Theme) => ({
    fontSize: '20px',
    color: theme.palette.text.secondary,
  }),
  groupIcon: {
    height: '20px',
    width: '20px',
  },
  boldText500: {
    fontWeight: 500,
  },
  alertCircle: (theme: Theme) => ({
    fontSize: '10px',
    color: theme.palette.error.main,
  }),
  drawerLink: {
    fontWeight: 500,
    fontSize: 'inherit',
  },
  dialogPaper: (theme: Theme) => ({
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    width: '400px',
    maxWidth: '100%',
  }),
  deviceItemContainer: (isSmallScreen: boolean, theme: Theme, isSelected: boolean) => ({
    borderRadius: 2,
    backgroundColor: isSelected ? theme.palette.secondary.light : theme.palette.background.paper,
    paddingX: 2,
    paddingY: 2.5,
    gap: 1.5,
    flexDirection: isSmallScreen ? 'column' : 'row',
    cursor: 'pointer',
  }),
  deviceItemInfoContainer: (isSmallScreen: boolean) => ({
    display: 'flex',
    flex: 1,
    gap: 1,
    flexDirection: isSmallScreen ? 'column' : 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  }),
  deviceItemTextContainer: {
    flexDirection: 'column',
    gap: '2px',
  },
  deviceItemNodeTypeText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  deviceItemLocationText: {
    fontWeight: 500,
  },
  deviceItemStatusColumn: {
    flexDirection: 'column',
  },
  deviceItemStatusRow: (isSmallScreen: boolean) => ({
    flexDirection: 'column',
    justifyContent: isSmallScreen ? 'flex-start' : 'flex-end',
    gap: 1,
  }),
  deviceItemIssueIconsRow: {
    gap: 0.5,
    alignItems: 'center',
  },
  deviceGroupDetailsContainer: {
    flexDirection: 'column',
    gap: 1,
  },
  extraSensorsPanel: {
    flexDirection: 'column',
    gap: 1,
    paddingY: 1,
  },
  extraSensorsList: (theme: Theme) => ({
    flexDirection: 'column',
    gap: 1,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 2,
    padding: 1,
    paddingY: 2,
  }),
  extraSensorListItem: (theme: Theme) => ({
    padding: theme.spacing(1.5, 2),
  }),
  extraSensorsPanelHeader: {
    paddingX: 2,
  },
  extraSensorsStandalonePanel: {
    width: '100%',
  },
  extraSensorsActivateButton: {
    alignSelf: 'center',
    minWidth: '120px',
  },
  deviceChipContainer: (isMobile: boolean) => ({
    flexDirection: 'column',
    gap: 1,
    alignItems: isMobile ? 'flex-start' : 'flex-end',
  }),
  statusChipButton: (isActionNeeded: boolean, theme: Theme) => ({
    border: `1px solid ${isActionNeeded ? alpha(theme.palette.error.main, 0.7) : alpha(theme.palette.primary.main, 0.7)}`,
    borderRadius: '8px',
    paddingX: 1,
    paddingY: 0.5,
    display: 'flex',
    gap: 1,
  }),
  statusChipText: (isActionNeeded: boolean, theme: Theme) => ({
    fontStyle: 'italic',
    color: isActionNeeded ? theme.palette.error.main : theme.palette.primary.main,
  }),
  statusChipInfoIcon: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  issueWarningIcon: (theme: Theme) => ({
    color: theme.palette.warning.light,
  }),
  bookmarkDescription: {
    marginBottom: 2,
  },
  skeletonGrid: {
    marginTop: 2,
    gap: 1,
  },
  skeletonButtonGroup: {
    marginY: 1.5,
  },
}

export default useStyles
